<template>
  <h2 style="max-width: 600px; text-align: justify; margin-top: 40px">В личном кабинете Вы можете узнать номер и срок действия своего договора, а также оставить заявку на сервис или обслуживание оборудования.</h2>
  <div>
    <form class="wrapper" @submit.prevent="onLogin">
      <h1>Войти в систему</h1>

      <div :class="['form-control', {invalid: emailError}]">
        <label for="email">Email</label>
        <input type="email" id="email" v-model="email" @blur="emailBlur">
        <small v-if="emailError">{{ emailError }}</small>
      </div>

      <div :class="['form-control', {invalid: passwordError}]">
        <label for="password">Пароль</label>
        <input type="password" id="password" v-model="password" @blur="passwordBlur">
        <small v-if="passwordError">{{ passwordError }}</small>
      </div>

      <button class="login" type="submit" :disabled="isSubmitting || isTooManyAttempts">Войти</button>
      <div class="text-danger" v-if="isTooManyAttempts">Вы слишком часто пытаетесь войти в систему. Попробуйте позже.</div>

    </form>
  </div>
</template>

<script>

import {useLoginForm} from "@/components/use/login-form";

export default {
 setup() {
    return{...useLoginForm()}
 }
}
</script>

<style scoped>

form {
  max-width: 1400px;
}

h1 {
  text-align: center;
}

h2 {
  padding: 20px;
}

.auth-buttons {
  display: flex;
  flex-direction: row;
  margin: 10px;
}

.wrapper {
  display: flex;
  flex-direction: column;
}

.login, .register {
  margin: 10px;
  padding: 10px;
}

@media (max-width: 400px) {
  h2 {
    font-size: 24px;
    text-align: center;
  }
}

</style>